/**
 * [LOGEIX] Notify Me modal: heart-trigger population + PetPoS form submission.
 * Loaded from layout/theme.liquid (defer).
 */
(function () {
  var dialog = document.getElementById('modal-notify-me');
  if (!dialog) return;

  var form = dialog.querySelector('.lgx-notify-me__form');
  var img = document.getElementById('lgx-notify-me-img');
  var recordIdInput = document.getElementById('lgx-notify-me-record-id');
  var feedback = dialog.querySelector('.lgx-notify-me__feedback');
  var breedSpans = dialog.querySelectorAll('.js-lgx-notify-breed');

  function setBreed(raw) {
    var lower = (raw || '').toLowerCase();
    breedSpans.forEach(function (span) {
      span.textContent = lower;
    });
  }

  function resetModal() {
    if (img) { img.src = ''; img.alt = ''; }
    setBreed('');
    if (recordIdInput) recordIdInput.value = '';
    if (form) form.reset();
    if (feedback) { feedback.textContent = ''; feedback.className = 'lgx-notify-me__feedback'; }
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lgx-notify-trigger]');
    if (!trigger) return;

    e.preventDefault();
    e.stopPropagation();

    resetModal();

    if (img) {
      img.src = trigger.dataset.notifyImageSrc || '';
      img.alt = trigger.dataset.notifyImageAlt || '';
    }
    setBreed(trigger.dataset.notifyBreed || '');
    if (recordIdInput) recordIdInput.value = trigger.dataset.notifyRecordId || '';

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  });

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var apiUrl = form.dataset.apiUrl || '';
    var petshopId = form.dataset.petshopId || '21';

    var firstName = (form.elements['firstName'] || {}).value || '';
    var mobileNo = (form.elements['mobileNo'] || {}).value || '';
    var email = (form.elements['email'] || {}).value || '';
    var notifyChanges = form.elements['notifyChanges'] ? form.elements['notifyChanges'].checked : false;
    var notifyNewArrivals = form.elements['notifyNewArrivals'] ? form.elements['notifyNewArrivals'].checked : false;
    var medicalRecordId = recordIdInput ? recordIdInput.value : '';

    if (!mobileNo) {
      showFeedback('Please enter your mobile number.', 'error');
      return;
    }

    var submitBtn = form.querySelector('.lgx-notify-me__submit');
    if (submitBtn) submitBtn.disabled = true;

    fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'petshopid': petshopId
      },
      body: JSON.stringify({
        firstName: firstName,
        mobileNo: mobileNo,
        email: email,
        notifyChanges: notifyChanges,
        notifyNewArrivals: notifyNewArrivals,
        MedicalRecordId: medicalRecordId
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed (' + res.status + ')');
        showFeedback('You’re all set! We’ll keep you updated.', 'success');
        setTimeout(function () {
          if (dialog.open) dialog.close();
        }, 2000);
      })
      .catch(function () {
        showFeedback('Something went wrong. Please try again or call us at (888) 670-4355.', 'error');
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  function showFeedback(msg, type) {
    if (!feedback) return;
    feedback.textContent = msg;
    feedback.className = 'lgx-notify-me__feedback lgx-notify-me__feedback--' + type;
  }
})();
